module.exports = __webpack_public_path__ + "static/media/visit.32a74860.png";